import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import FireworksOverlay from '../../components/common/FireworksOverlay';
import './HomePage.css';

const services = [
  {
    icon: '🖌️',
    title: 'AI 智能体改图',
    url: '/ai-image',
    link: '/ai-image',
    isInternal: true,  // 内部路由
    docLink: 'http://172.16.16.16/help/a.html',
    desc:"一键完成各类设计改图与快速迭代"
  },
  {
    icon: '🎨',
    title: 'Stable Diffusion',
    url: '172.16.9.9:7860',
    link: 'http://172.16.9.9:7860/',
    docLink: 'https://docs.turen.design',
    desc:"强大土人风格渲染精细化出图能力"
  },
  {
    icon: '✨',
    title: '新版 SD',
    url: '/stable-diffusion',
    link: '/stable-diffusion',
    // isInternal: true,
    badge: '建设中',
    // badgeType: 'highlight',
    desc:"强大土人风格渲染精细化出图能力"
  },
  {
    icon: '📝',
    title: '提示词反推',
    url: '172.16.16.16:3300',
    link: 'http://172.16.16.16:3300',
    badge: '建设中',
    desc:"帮助快速写出高质量提示词"
  },
  {
    icon: '💬',
    title: 'AI Chat',
    url: '172.16.16.16:3400',
    link: 'http://172.16.16.16:3400',
    badge: '基于Gemma大语言模型',
    badgeType: 'highlight',
    desc:"高效生成专业项目与标书文本"
  },
  {
    icon: '🔧',
    title: '高清修复',
    url: '172.16.16.16:3500',
    link: 'http://172.16.16.16:3500',
    badge: '建设中',
    desc:"智能修复细节，提升图像清晰度"
  },
  {
    icon: '💬',
    title: '意见墙',
    url: '/opinion',
    link: '/opinion',
    isInternal: true,  // 内部路由
    desc:"提交您的意见与建议，帮助我们改进"
  },
];

const HomePage = () => {
  const { isAuthenticated, user } = useAuth();
  const [showFireworks, setShowFireworks] = useState(false);

  // Entering HomePage: auto play fireworks once.
  useEffect(() => {
    setShowFireworks(true);
  }, []);

  const handleFuClick = useCallback(() => {
    // restart fireworks if already running
    setShowFireworks(false);
    window.setTimeout(() => setShowFireworks(true), 0);
  }, []);

  return (
    <div className="home-page">
      <FireworksOverlay active={showFireworks} durationMs={5000} onComplete={() => setShowFireworks(false)} />
      {/* Animated background */}
      <div className="home-bg">
        <div className="home-bg-shape shape-1"></div>
        <div className="home-bg-shape shape-2"></div>
        <div className="home-bg-shape shape-3"></div>
        <div className="home-bg-grid"></div>
      </div>

      {/* Navigation */}
      <nav className="home-nav">
        <div className="home-nav-logo">
          <svg viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="10" fill="url(#home-logo-grad)" />
            <path d="M20 10L28 26H12L20 10Z" fill="white" fillOpacity="0.9" />
            <circle cx="20" cy="28" r="3" fill="white" />
            <defs>
              <linearGradient id="home-logo-grad" x1="0" y1="0" x2="40" y2="40">
                <stop stopColor="#0d9488" />
                <stop offset="1" stopColor="#0f766e" />
              </linearGradient>
            </defs>
          </svg>
          <span>Turen Design</span>
        </div>
        <div className="home-nav-actions">
          {isAuthenticated ? (
            <>
              <span className="home-nav-user">欢迎，{user?.real_name || user?.username}</span>
              <Link to="/dashboard" className="home-nav-btn primary">
                进入控制台
              </Link>
            </>
          ) : (
            <Link to="/login" className="home-nav-btn primary">
              登录
            </Link>
          )}
        </div>
      </nav>

      {/* Hero */}
      <header className="home-hero">
        <div className="home-hero-content">
          <div className="home-newyear-banner" role="note" aria-label="元旦祝福">
            <span className="home-newyear-badge">2026 元旦快乐</span>
            <span className="home-newyear-text">祝大家新的一年灵感开花、项目顺利、心想事成</span>
            
          </div>
          <h1 className="home-title" onClick={handleFuClick}>
            <span className="title-icon" aria-hidden="true" >🧧</span>
            AI 设计工作台
          </h1>
          <p className="home-subtitle">智能创意工具，赋能设计未来</p>
        </div>
      </header>

      {/* Services Grid */}
      <main className="home-main">
        <div className="services-grid">
          {services.map((service, index) => (
            <article
              key={service.title}
              className="service-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {service.isInternal ? (
                <Link to={service.link} className="service-link">
                  <div className="service-icon-wrapper">
                    <span className="service-icon">{service.icon}</span>
                    <div className="service-icon-glow"></div>
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">{service.title}</h3>
                    {service.desc && (
                      <p className="service-desc">{service.desc}</p>
                    )}
                    {service.badge && (
                      <span className={`service-badge ${service.badgeType || ''}`}>
                        {service.badge}
                      </span>
                    )}
                  </div>
                  <div className="service-arrow">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </div>
                </Link>
              ) : (
                <a href={service.link} target="_blank" rel="noopener noreferrer" className="service-link">
                  <div className="service-icon-wrapper">
                    <span className="service-icon">{service.icon}</span>
                    <div className="service-icon-glow"></div>
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">{service.title}</h3>
                    {service.desc && (
                      <p className="service-desc">{service.desc}</p>
                    )}
                    {service.badge && (
                      <span className={`service-badge ${service.badgeType || ''}`}>
                        {service.badge}
                      </span>
                    )}
                  </div>
                  <div className="service-arrow">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </div>
                </a>
              )}
              {service.docLink && (
                <a href={service.docLink} target="_blank" rel="noopener noreferrer" className="service-doc">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                  </svg>
                  使用手册
                </a>
              )}
            </article>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="home-footer">
        <p className="footer-tagline">AI 创意工具 · 设计赋能</p>
        <p className="footer-credits">
          Crafted with <span className="footer-heart">♥</span> by{' '}
          <a href="http://www.turen.design" target="_blank" rel="noopener noreferrer">
            Turen Design
          </a>
        </p>
      </footer>
    </div>
  );
};

export default HomePage;

